import React, { ReactNode } from 'react';
import { TileInfo } from 'app/home/index.functions';
import { TileInfoIcon } from 'components/tile-info-icon';

export const TileInfoIconLine = function ({
    style,
    tile,
    children,
}: {
    style?: any;
    tile: TileInfo;
    children?: ReactNode;
}) {
    let defaultStyle = {};

    return (
        <TileInfoIcon tile={tile} style={style} defaultStyle={defaultStyle}>
            {children}
        </TileInfoIcon>
    );
};
